<template>
  <v-app>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      right
      temporary
      app
    >
      <v-list>
        <v-list-item router to="/" exact>
          <v-list-item-action>
            <v-icon light>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item router to="/settings">
          <v-list-item-action>
            <v-icon light>settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-3"></v-divider>
        <v-list-item v-if="user !== null" router @click="onLogout">
          <v-list-item-action>
            <v-icon light>exit_to_app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app fixed color="primary" dark>
      <v-toolbar-title>
        Document Management
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" right></v-app-bar-nav-icon>
    </v-app-bar>
    <v-alert :value="appOutdated" color="warning" icon="history" style="position: fixed;top: 60px;width: 100%;z-index: 100;">The application has an update available <v-btn color="success" @click="resetApp" depressed>Click here to update</v-btn></v-alert>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        drawer: false,
        fixed: false,
        connected: true,
        disclaimer: false
      }
    },
    created () {
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      appOutdated () {
        return this.$store.getters.appOutdated
      },
      applicationMode () {
        return this.$store.getters.applicationMode
      }
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      onLogout () {
        this.$store.dispatch('logout')
        this.$router.push('/SignIn')
      },
      showDisclaimer () {
        this.disclaimer = true
      },
      resetApp () {
        navigator.serviceWorker.getRegistrations()
          .then(function (registrations) {
            for (let registration of registrations) {
              registration.unregister()
            }
          })
          .then(function (boolean) {
            caches.delete('dms-cache').then(function (boolean) {
              window.location.reload(true)
            })
          })
      }
    }
  }
</script>

<style>
  .v-application .headline, .v-application .title, .v-application, .v-application .body-1, .v-application .caption, .v-application .body-2, .v-application .subtitle-1 {
    font-family: 'Rubik' !important;
  }
  html, body {
    overscroll-behavior: none;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue